<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-cogs</v-icon>
              <span class="px-3">{{ $t('Edit Outlet Information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 sm4 md3>
              <v-layout row wrap justify-content-start style="margin:0 auto; max-width:200px;">
                <v-flex xs12>
                  <label @click="chooseImage" style="cursor:pointer">
                    <v-hover>
                      <v-card slot-scope="{ hover }" flat color="grey lighten-4" max-width="600">
                        <div class="user-image" :style="{ 'background-image': `url(${imageData})` }">
                          <span v-if="!imageData" class="placeholder">
                            <v-img
                                :src="
                                outletInfo.attachment === null || outletInfo.attachment == undefined
                                  ? `${baseUrls.images}/no-image-available.png`
                                  : `${baseUrls.images}/${outletInfo.attachment}`
                              "
                                height="232"
                            />
                          </span>
                          <v-expand-transition>
                            <div
                                v-if="hover"
                                class="transition-fast-in-fast-out v-card--reveal white--text headline image-upload-overlay"
                            >
                              <div class="overlay-inner-content">
                                {{ $t('Click To Upload') }}
                              </div>
                            </div>
                          </v-expand-transition>
                        </div>
                      </v-card>
                    </v-hover>
                  </label>
                </v-flex>
                <input
                    type="file"
                    name="attachment"
                    ref="fileInput"
                    style="visibility:hidden; width:0; position:absolute; top:-9999px"
                    v-validate="'size:2047|ext:jpeg,jpg,png'"
                    @input="onSelectFile"
                />
                <label @click="chooseImage" class="info white--text file-upload-trigger" ripple>{{
                    $t('Upload Image')
                  }}</label>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm8 md9>
              <v-layout row wrap justify-content-end>
                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.outlet_name"
                      :label="`${$t('Outlet Name')} *`"
                      name="outlet_name"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('outlet_name')"
                      v-validate="'required'"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.outlet_phone"
                      :label="$t('Phone')"
                      name="outlet_phone"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('outlet_phone')"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.outlet_email"
                      :label="$t('Email')"
                      name="outlet_email"
                      box
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('outlet_email')"
                      v-validate="'email'"
                      data-vv-validate-on="blur"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.outlet_website"
                      :label="$t('Website')"
                      name="outlet_website"
                      box
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('outlet_website')"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.company_name_en"
                      :label="`${$t('Company Name (en)')} *`"
                      name="company_name_en"
                      box
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('company_name_en')"
                      v-validate="'required'"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.company_name_ar"
                      :label="`${$t('Company Name (ar)')} *`"
                      name="company_name_ar"
                      box
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('company_name_ar')"
                      v-validate="'required'"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.outlet_slogan_en"
                      :label="`${$t('Outlet Slogan (en)')} *`"
                      name="outlet_slogan_en"
                      box
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('outlet_slogan_en')"
                      v-validate="'required'"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="pa-2">
                  <v-text-field
                      v-model="outletInfo.outlet_slogan_ar"
                      :label="`${$t('Outlet Slogan (ar)')} *`"
                      name="outlet_slogan_ar"
                      box
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('outlet_slogan_ar')"
                      v-validate="'required'"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 class="pa-2">
                <v-text-field
                    v-model="outletInfo.user_per_outlet"
                    :label="$t('User Per Outlet')"
                    name="user_per_outlet"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_per_outlet')"
                    v-validate="'required|numeric'"
                />
              </v-flex>

              <v-flex xs12 class="pa-2">
                <v-textarea
                    v-model="outletInfo.outlet_address"
                    :label="$t('Address')"
                    name="outlet_address"
                    box
                    hide-details
                    height="80"
                    background-color="white"
                    :error="errors.has('outlet_address')"
                />
              </v-flex>
            </v-layout>

            <v-flex xs12 class="px-2">
              <v-layout justify-start>
                <v-flex sm3 md2 class="pt-3">
                  <v-chip
                      label
                      :color="outletInfo.is_active === 'Active' ? 'success' : 'error'"
                      text-color="white"
                  >
                    <v-icon left tabindex="-1">{{
                        outletInfo.is_active === 'Active' ? 'check_circle' : 'block'
                      }}</v-icon>
                    {{ outletInfo.is_active === 'Active' ? $t('Active') : $t('Inactive') }}
                  </v-chip>
                </v-flex>
                <v-checkbox
                    v-model="outletInfo.is_active"
                    :label="$t('Active')"
                    true-value="Active"
                    false-value="Inactive"
                    color="primary"
                    messages="Please note that if this option is unchecked this outlet will not be accessible."
                />

              </v-layout>
            </v-flex>

          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
            >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      imageData: null,
      imageInput: null,
      imageFile: null
    }
  },

  computed: {
    ...mapGetters({
      outletInfo: 'outlets/getOutletInfo',
      baseUrls: 'misc/getBaseUrls'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.imageData = null
          this.imageInput = null
          this.imageFile = null
          this.$refs.fileInput.value = ''

          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateOutletInfo: 'outlets/updateOutletInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    chooseImage() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.imageInput = this.$refs.fileInput
      this.imageFile = this.imageInput.files

      if (this.imageFile && this.imageFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(this.imageFile[0])
      }
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          if (this.imageFile !== null) {
            formData.append('attachment', this.imageFile[0])
          }
          formData.append('is_active', this.outletInfo.is_active)

          let payload = { id: this.outletInfo.outlet_id, formData }

          this.updateOutletInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
        }
      })
    }
  }
}
</script>

<style scoped />
